<nz-tag [nzColor]="class" [ngClass]="type === 'CANCELED' ? 'color color__default' : 'color'">{{ status }}</nz-tag>
